var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpi1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 165,
    viewBox: "0 0 301 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.818848,
    y: 0.160156,
    width: 299.606,
    height: 164.676,
    rx: 18.2983,
    fill: "#E31F26"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4374",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 301,
    height: 165
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.818848,
    y: 0.160156,
    width: 299.606,
    height: 164.676,
    rx: 18.2983,
    fill: "#E31F26"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.922 -5.74692C141.772 76.3015 141.085 152.429 158.26 180.236L314.8 186.125C362.237 87.9807 355.267 -48.6854 281.922 -5.74692Z",
    fill: "#E9E1E1",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.566 -3.9961C148.74 93.5689 156.779 169.273 177.027 194.93L333.211 182.845C369.09 79.9129 346.509 -55.0548 278.566 -3.9961Z",
    fill: "#E9E1E1",
    fillOpacity: 0.08
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpi1);
export default __webpack_public_path__ + "static/media/kpi1.fde62ee17f409d3f3b6264ef05130d7d.svg";
export { ForwardRef as ReactComponent };